import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { type NextBestAction } from '@post-office/confluence-next-best-action';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import { PlacementFrontend } from '@post-office/browser--growth/confluence-side-nav';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import type { MessageTemplateContext } from '../../../index';

import { ConfluenceAgentsMcpNudgeBanner } from './components/confluence-agents-mcp-nudge-banner';

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onSideNavClick: (nextBestActionType: NextBestAction) => void;
};

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ handleOnDismissed, onSideNavClick }: MessageFrontendProps) => (
			<ConfluenceAgentsMcpNudgeBanner onDismiss={handleOnDismissed} onSetup={onSideNavClick} />
		),
	},
});
